import { useEffect } from 'react'

// Shared close-on-Escape hook for popovers, drawers and slide-overs (v001 §3).
// The keydown listener is only attached while `open` is true and is removed on
// cleanup (close, unmount, or handler change).
export const useEscClose = (open: boolean, onClose: () => void): void => {
  useEffect(() => {
    if (!open) return
    const handler = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [open, onClose])
}

export default useEscClose
